import { useCallback, useRef } from 'react';
import { fetchBudgetServiceItems, IBudgetServiceItemOption } from '../../../../api/fetchBudget';
import BudgetSelectCustom from './BudgetSelectCustom';

interface IBudgetDescriptionSelectProps {
  value: string;
  onChange: (option: { id: string; label: string; itemData?: IBudgetServiceItemOption } | undefined) => void;
  disabled?: boolean;
  isRemoved?: boolean;
  autoFocus?: boolean;
}

const BudgetDescriptionSelect = (props: IBudgetDescriptionSelectProps) => {
  const allDataRef = useRef<Array<{ id: string; label: string; itemData?: IBudgetServiceItemOption }>>([]);

  const loadDescriptionData = useCallback(
    async (
      searchTerm: string,
      limit: number,
    ): Promise<Array<{ id: string; label: string; itemData?: IBudgetServiceItemOption }>> => {
      try {
        const page = 1;
        const searchLimit = searchTerm && searchTerm.trim() !== '' ? 10 : limit;
        const items = await fetchBudgetServiceItems(searchTerm, searchLimit, page);
        
        const mappedItems = items
          .filter((item) => item.itemData?.description) // Filtra apenas itens com descrição
          .map((item) => {
            if (!item.itemData) {
              return {
                id: item.id,
                label: item.label,
                itemData: undefined,
                value: item.value,
              };
            }
            
            const description = item.itemData.description || '';
            const itemCode = item.itemData.item || item.id || '';
            const label = itemCode ? `${description} (${itemCode})` : description;
            
            return {
              id: description,
              label: label,
              itemData: item.itemData,
              value: item.value,
            };
          });
        
        allDataRef.current = mappedItems;
        return mappedItems;
      } catch (error) {
        console.error('[BudgetDescriptionSelect] erro ao carregar dados', error);
        if (allDataRef.current.length > 0) {
          return allDataRef.current;
        }
        return [];
      }
    },
    [],
  );

  const handleChange = useCallback((option: { id: string; label: string; itemData?: IBudgetServiceItemOption } | undefined) => {
    if (option) {
      const descriptionOnly = option.id || option.label.split(' (')[0] || option.label;
      props.onChange({
        ...option,
        id: descriptionOnly,
        label: option.label,
      });
    } else {
      props.onChange(undefined);
    }
  }, [props]);

  return (
    <BudgetSelectCustom
      value={props.value ? [props.value] : []}
      onChange={handleChange}
      loadData={loadDescriptionData}
      disabled={props.disabled}
      isRemoved={props.isRemoved}
      autoFocus={props.autoFocus}
      openOnFocus={false}
      initialLimit={10}
      placeholder="Pesquisar por descrição"
      inputBorderColor="#14b8a6"
      inputBackgroundColor="#ffffff"
      dropdownBackgroundColor="#ffffff"
      highlightedOptionColor="#3b82f6"
      selectedOptionColor="#e5e7eb"
    />
  );
};

export default BudgetDescriptionSelect;

